import React, { useState, useEffect } from "react";
import './SubTeamMeeting.scss';
import Participant from "../../partials/Participant/Participant";
import Popup from './partials/Popup/Popup';
import SubTeamQuiz from './subteamQuiz';
import OrbitReferences from '../OrbitReferences/OrbitReferences';
import Feedback from './feedback/feedback';
import Button from '../../partials/Button'
import MeetingConclusion from "./meeting-conclusion/MeetingConclusion";
import BackButton from '../../partials/Button/BackButton';
import Scroll from '../../partials/Scroll/Scroll'


import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Instructions from "../../partials/Instructions/Instructions";

const SubTeamMeeting = (props) => {
    const data = props.data;
    console.log(data)
    const [slideIndex, setSlideIndex] = useState(0);
    const [roundIndex, setRoundIndex] = useState(0);
    const [quizIndex, setQuizIndex] = useState(0);
    const [selectedParticipant, setSelectedParticipant] = useState(null)
    const [showDialogue, setShowDialogue] = useState(false);
    const [showFeedback, setShowFeedback] = useState(null);
    const [feedbackData, setFeedbackData] = useState({ scrim: true, header: "", body: "", button: "Close", config: data?.config });
    const [alert, setAlert] = useState([])
    const [intervened, setIntervened] = useState(false)
    const [interveneNext, setInterveneNext] = useState(null);
    const [pageState, setPageState] = useState("main");
    const [showOrbit, setShowOrbits] = useState(false);
    const [showMeeting, setShowMeeting] = useState(true);
    const [intervenArray, setInterveneArray] = useState({ "correct": [], "wrong": [], "missed": [] })
    const [showInterveneDialogue, setShowInterveneDialogue] = useState(false);
    const [lastSlide, setLastSlide] = useState(false);

    let handleNextRound = () => {
        setShowDialogue(false)
        setShowInterveneDialogue(false)
        setLastSlide(false)
        setSlideIndex(0)

        if (roundIndex === data.rounds.length - 1) {
            console.log("all done")
            setPageState("feedback")
        } else {
            setRoundIndex(roundIndex + 1)
            let newFeedback = feedbackData
            newFeedback.body = data.setup
            newFeedback.header = "Scenario"
            newFeedback.button = "Close"
            setFeedbackData(feedbackData)
            setShowFeedback(true)
        }
    }

    let handleNextQuiz = (i) => {
        if (quizIndex === data.quiz.length - 1) {
            console.log("all quiz done")
            let choice = data.quiz[quizIndex].options[i].text
            let index = data.conclusion.indexOf("$")
            let newCon = data.conclusion.substring(0, index) + choice + data.conclusion.substring(index + 1);
            let newFeedback = feedbackData;
            newFeedback.header = "Conclusion"
            newFeedback.body = newCon
            newFeedback.button = "Next"
            setFeedbackData(newFeedback)
            props.onComplete();
        } else {
            setQuizIndex(quizIndex + 1)
        }
    }

    let handleIntervene = (part) => {
        setShowInterveneDialogue(true);
        if (part != null) {
            console.log(part.intervene)
            if (part.intervene) {
                console.log("right")
                let feedback = feedbackData
                feedback.header = "Nice Job!"
                feedback.body = part.feedback
                setFeedbackData(feedback)
                setShowFeedback(true)
                setIntervened(true)
                console.log("Intervened after correct intervention: ", intervened)
                interveneFilter('correct', part)
            } else {
                console.log("wrong")
                let feedback = feedbackData
                feedback.header = "Oh No!"
                feedback.body = part.feedback
                setFeedbackData(feedback)
                setShowFeedback(true)
                interveneFilter('wrong', part)
            }
        }
    }

    let handleQuizComplete = (i) => {
        let choice = data.quiz.options[i].text
        let index = data.conclusion.indexOf("$")
        let newCon = data.conclusion.substring(0, index) + choice + data.conclusion.substring(index + 1);

        let newFeedback = feedbackData;
        newFeedback.header = "Conclusion"
        newFeedback.body = newCon
        newFeedback.button = "Next"
        setFeedbackData(newFeedback)
        setShowFeedback(true)
    }

    let handleClose = () => {
        if (pageState === "quiz" && feedbackData.header === "Conclusion") {
            props.markComplete()
            return
        } else {
            setShowFeedback(false)
        }
    }

    let handleInfoClick = () => {
        let newFeedback = feedbackData
        newFeedback.header = "Info"
        newFeedback.body = data.instructions
        newFeedback.button = "Close"
        setFeedbackData(newFeedback)
        setShowFeedback(true)
    }

    let handleParticipantClick = (participant) => {
        setShowInterveneDialogue(false);
        setSelectedParticipant(participant)
        if (slideIndex - 1 >= 0) {
            let intervene = data.rounds[roundIndex].slides[slideIndex - 1].participants.findIndex(x => x.intervene === true)

            if (intervene != -1) {
                setInterveneNext(true)
            }

            console.log("Intervened before if: ", intervened)
            if (intervened === false && interveneNext && intervene != -1) {
                console.log("missed")
                let feedback = feedbackData
                feedback.header = "Oh No!"
                feedback.body = `What ${data.rounds[roundIndex].slides[slideIndex - 1].participants[intervene].name} said needed to be intervened on. ${data.rounds[roundIndex].slides[slideIndex - 1].participants[intervene].feedback}`
                setFeedbackData(feedback)
                setShowFeedback(true)
                setIntervened(true)
                interveneFilter('missed', data.rounds[roundIndex].slides[slideIndex - 1].participants[intervene])
            }
            else {
                setIntervened(false)
            }
        }
        let nextSlideIndex = data.rounds[roundIndex].slides.findIndex(s => s.slide === participant.nextSlide)
        setSlideIndex(nextSlideIndex)
    }

    let interveneFilter = (type, data) => {
        let newData = {
            "name": data.name,
            "dialogue": data.dialogue,
            "feedback": data.feedback,
            "image": data.img
        }
        let newArray = intervenArray
        newArray[type].push(newData);
        setInterveneArray(newArray);
        console.log(newArray)

    }

    useEffect(() => {
        if (selectedParticipant != null) {
            if (selectedParticipant.dialogue != null && selectedParticipant.dialogue != "") {
                setShowDialogue(true);
            }
            else {
                setShowDialogue(false);
            }
        }
    }, [selectedParticipant])

    useEffect(() => {
        setShowMeeting(pageState === "main");
    }, [pageState])

    useEffect(() => {
        let newArr = [...data.rounds[roundIndex].slides[slideIndex].participants.map(x => x.initialState === "alert")]
        setAlert(newArr)
        let newFeedback = feedbackData
        newFeedback.body = data.setup
        newFeedback.header = "Scenario"
        newFeedback.button = "Close"
        setFeedbackData(feedbackData)
        setShowFeedback(true)
    }, [])

    useEffect(() => {
        let newArr = [...data.rounds[roundIndex].slides[slideIndex].participants.map(x => x.initialState === "alert")]
        setAlert(newArr)
        setIntervened(false)
        setInterveneNext(false)
        if (data.rounds[roundIndex].slides[slideIndex].participants.findIndex(x => x.initialState === "previous") === data.rounds[roundIndex].slides[slideIndex].participants.findIndex(x => x.isIntervene === true)) {
            setInterveneNext(true)
        }
    }, [roundIndex])

    useEffect(() => {
        if (data.rounds[roundIndex].slides[slideIndex].isLast) {
            setLastSlide(true)
        }
    }, [slideIndex])

    useEffect(() => {
        console.log(intervenArray)
    }, [intervenArray])

    const getParticipantsArray = () => {
        if (!data.rounds[roundIndex].slides[slideIndex].isLast) {
            return data.rounds[roundIndex].slides[slideIndex].participants.map((participant, i) => {
                return <Participant
                    key={"participant-" + participant.key}
                    data={data}
                    name={participant.name}
                    dialogue={participant.dialogue}
                    image={participant.img}
                    alert={participant.initialState !== "previous" && alert[i]}
                    active={participant.initialState}
                    scale={participant.scale}
                    showDialog={true}
                    onClick={() => handleParticipantClick(participant)}
                />
            })
        } else {
            return data.rounds[roundIndex].slides[slideIndex - 1].participants.map((participant, i) => {
                return <Participant
                    key={"participant-" + participant.key}
                    data={data}
                    name={participant.name}
                    dialogue={null}
                    image={participant.img}
                    alert={false}
                    active={participant.initialState}
                    scale={participant.scale}
                    showDialog={true}
                    onClick={() => handleParticipantClick(participant)}
                />
            })

        }

    }
    const participantsArray = getParticipantsArray();


    return (
        <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
            <div className="back-btn-container">
                <BackButton text={"Back"} onClick={props.goBackToPreviousSegment} />

            </div>
            {pageState === "main" &&
                <Instructions body={data.instructions} />
            }

            <div className={`SubTeamMeeting`} style={{ backgroundImage: showMeeting ? "url(media/img/background/subteam-meeting-background.png)" : "" }}>
                {pageState === "main" &&
                    <>
                        <div className="references">
                            <Button className="references" text={data?.config?.orbitReferencesButton} onClick={() => setShowOrbits(true)} />
                        </div>


                        {showDialogue &&
                            <>
                                <Scroll>
                                    <div className="Dialogue">
                                        {selectedParticipant.dialogue}
                                        {
                                            showInterveneDialogue &&
                                            <>
                                                < div className="interveneDialogue">
                                                    <img src={data?.config?.interveneIcon || "media/img/intervene_icon.png"} alt={data?.config?.interveneIconAlt} />
                                                </div>
                                            </>
                                        }
                                    </div>
                                </Scroll>
                            </>
                        }
                        <div className={`participant-section`}>
                            {participantsArray}
                        </div>
                        <div className={`footer`}>
                            <div>
                                {
                                    lastSlide &&
                                    <Button text="Next" onClick={handleNextRound}>Next</Button>
                                }
                            </div>
                            <div className="leader">
                                <div className={`profile`}>
                                    <img src={data?.config?.interveneImage || "media/img/subteam_meeting/participant_5"} alt={data?.config?.interveneImageAlt} />
                                </div>
                                <Button onClick={() => handleIntervene(selectedParticipant)} text={data?.config?.interveneButton} />
                            </div>
                        </div>
                    </>
                }
                {
                    pageState === "feedback" &&
                    <>
                        <Feedback
                            intervenArray={intervenArray}
                            quizClick={() => setPageState('quiz')}
                        />
                    </>
                }
                {pageState === "quiz" &&
                    <>
                        <SubTeamQuiz data={data.quiz[quizIndex]} config={data.config} onComplete={(e) => handleNextQuiz(e)} />
                    </>
                }
                {pageState === "conclusion" &&
                    <>
                        <MeetingConclusion data={feedbackData} />
                    </>
                }
                {showFeedback &&
                    <Popup data={feedbackData} onClose={() => handleClose()} scrim={false} />
                }
                {showOrbit &&
                    <OrbitReferences data={data.references} toggle={() => setShowOrbits(false)} />
                }
            </div>
        </InteractionContainer >
    )
}

export default SubTeamMeeting
